import { IClassname } from '@/lib/shared/model/classname';

export const WorkArea = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14276_580)">
        <path
          d="M30.696 29.4272C30.696 29.7661 30.5614 30.0912 30.3217 30.3308C30.0821 30.5705 29.757 30.7051 29.4181 30.7051H23.0285C22.6896 30.7051 22.3646 30.5705 22.1249 30.3308C21.8853 30.0912 21.7506 29.7661 21.7506 29.4272V19.2039H1.30396V16.648C1.30396 16.3091 1.43859 15.9841 1.67825 15.7444C1.9179 15.5048 2.24295 15.3701 2.58187 15.3701H29.4181C29.757 15.3701 30.0821 15.5048 30.3217 15.7444C30.5614 15.9841 30.696 16.3091 30.696 16.648V29.4272Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.083 12.8145V15.3703"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.41561 1.31348H21.7506C21.7506 1.31348 23.0285 1.31348 23.0285 2.59139V11.5368C23.0285 11.5368 23.0285 12.8147 21.7506 12.8147H6.41561C6.41561 12.8147 5.1377 12.8147 5.1377 11.5368V2.59139C5.1377 2.59139 5.1377 1.31348 6.41561 1.31348Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.1377 9.62012H23.0285"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.30396 19.2041V30.7054"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.7507 19.2041H30.6961"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.7507 24.3164H30.6961"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_14276_580">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(0 0.00976562)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
